import { FunctionComponent } from 'react';
import { Container } from './MobileHeader.style';

export const MobileHeader: FunctionComponent = () => {
    return <Container data-testid="mobile-header"></Container>;
};

export default MobileHeader;
